import React, { useState, useMemo } from 'react';
import jwtDecode from 'jwt-decode';
import { OverlayVideoPlayer } from '../components/Video/OverlayVideoPlayer';
import { InformationModal } from '../components/Video/InformationModal';

export const UserContext = React.createContext({});

export function User({ children }) {
  const [video, setVideo] = useState(null);
  const [isPlayingVideo, setPlayingVideo] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const checkIfTokensIsValid = (accessToken) => {
    const decodedAccessToken = jwtDecode(accessToken);

    return (decodedAccessToken.exp - 180) * 1000 > new Date().getTime();
  };

  const isUserAllowedToPlayVideo = () => {
    const userFromLocalStorage = localStorage.getItem('user');
    if (!userFromLocalStorage) {
      return false;
    }

    const user = JSON.parse(userFromLocalStorage);
    const { accessToken } = user;
    const isTokenValid = checkIfTokensIsValid(accessToken);

    if (!isTokenValid) {
      localStorage.removeItem('user');
      window.location.replace('/auth/login');
      return false;
    }

    return isTokenValid;
  };

  const logout = () => {
    const userIsLoggedIn = localStorage.getItem('user');
    const userData = userIsLoggedIn ? JSON.parse(userIsLoggedIn) : null;
    const token = userData.idToken;
    const url = `${window.authBaseUrl}/logoutByToken?idToken=${token}&frontendCallback=${window.siteUrl}`;
    localStorage.removeItem('user');
    window.location.replace(url);
  };

  const playVideo = (v) => {
    const isAllowed = isUserAllowedToPlayVideo();
    // const isAllowed = true;
    if (isAllowed) {
      setVideo(v);
      setPlayingVideo(true);
    } else {
      setShowModal(true);
    }
  };

  const closeVideo = () => {
    setPlayingVideo(false);
    setVideo(null);
  };

  const contextValue = useMemo(
    () => ({
      playVideo,
      closeVideo,
      logout,
      isUserAllowedToPlayVideo
    }),
    [playVideo, closeVideo, logout, isUserAllowedToPlayVideo]
  );

  return (
    <UserContext.Provider value={contextValue}>
      {isPlayingVideo && (
        <OverlayVideoPlayer closeVideo={closeVideo} video={video} />
      )}
      {showModal && <InformationModal closeModal={() => setShowModal(false)} />}
      {children}
    </UserContext.Provider>
  );
}
